import JSONBigInt from 'json-bigint'

/**
 * Inventory Store
 *
 * @since 2018-04-12
 * @author dev014
 */

export const state = () => ({
  apiPreFix: '/api/lr/log/',
  logDetailInfoApi: 'detail/traffic',
  logDetailListApi: 'detail/traffic/related',
  // ===  onSearch ===
  search: {
    param: {
      log_id: '',
      session_id: '',
      stime: '',
      etime: ''
    }
  },
  detailData: {},
  logListData: []
})

export const mutations = {
}
export const actions = {
  // 로그 상세 페이지 결과 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    const param = state.search.param
    const apiUrl = `${state.apiPreFix}${state.logDetailInfoApi}`
    try {
      result = await this.$axios.$get(apiUrl, {params: {log_id: param.log_id, etime: param.etime, session_id: param.session_id}, transformResponse: [(data) => { return JSONBigInt.parse(data) }], loading: false})
      if (result.code === 'ok') {
        state.detailData = result.result.result
      } else {
        state.detailData = {}
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.detailData = {}
      return result
    }
  },
  // 로그 페이지 결과 조회
  async getDetailLogList ({commit, state}) {
    let result = {}
    const param = state.search.param
    const apiUrl = `${state.apiPreFix}${state.logDetailListApi}`
    try {
      result = await this.$axios.$get(apiUrl, {params: {stime: param.stime, etime: param.etime, session_id: param.session_id}, transformResponse: [(data) => { return JSONBigInt.parse(data) }], loading: false})
      if (result.code === 'ok') {
        state.logListData = result.result.log
      } else {
        state.logListData = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.logListData = []
      return result
    }
  }
}

export const getters = {}
export const strict = false
